import { Nav, NavItem, NavLink } from "react-bootstrap";
import { useLocation } from "react-router-dom";

import { SwitchAnimation } from "../../Animation/Animation.jsx";

import { NavBarItem } from "./NavBarItem.jsx";

export const CabinetNavbar = ({ data, activeUser, setActiveUser }) => {
  const location = useLocation();
  const isStudent = data[activeUser].role === "Ученик";
  return (
    <>
      <Nav
        className="mt-3 justify-content-center align-items-center"
        fill
        variant="pills"
        activeKey={activeUser}
      >
        {data.map((user, index) => {
          const { ref, name, role } = user;
          return (
            <NavItem key={ref} className="col-sm-auto">
              <NavLink
                style={{ cursor: "pointer" }}
                as="div"
                eventKey={index}
                onClick={() => setActiveUser(index)}
              >
                {name} - {role}
              </NavLink>
            </NavItem>
          );
        })}
      </Nav>
      <SwitchAnimation keyAnimation={activeUser}>
        <Nav
          className="mt-3 justify-content-center align-items-center"
          fill
          variant="pills"
          activeKey={location.pathname}
        >
          <NavBarItem
            linkTo=""
            eventKey="/cabinet/"
            className={isStudent ? "col-sm-6" : "col-sm-4"}
          >
            Главная
          </NavBarItem>
          <NavBarItem
            linkTo="finance/"
            eventKey="/cabinet/finance/"
            className={isStudent ? "col-sm-6" : "col-sm-4"}
          >
            Финансы
          </NavBarItem>
          {!isStudent && (
            <NavItem className="col-sm-4">
              <NavLink
                as="a"
                href="/presentations"
                eventKey="/cabinet/materials/"
              >
                Методические Материалы
              </NavLink>
            </NavItem>
          )}
        </Nav>
      </SwitchAnimation>
    </>
  );
};
